/* eslint-disable no-undef */
import { FunctionComponent } from 'react';
import CourseLanding from './../../components/courseLanding';
import SectionTitle from './../../components/sectionTitle';
import Conversation from './conversation';
import Animation001 from './animation001';
import Animation002 from './animation002';
import Animation003 from './animation003';
import Animation004 from './animation004';
import Animation005 from './animation005';
import Animation006 from './animation006';
import Animation013 from './animation013';
import Animation040 from './animation040';
import Animation042 from './animation042';
import Animation044 from './animation044';
import Animation045 from './animation045';
import Animation046 from './animation046';
import Animation047 from './animation047';
import Quiz from './../../components/quiz';
import Component001 from './component001';
import Component002 from './component002';
import Component003 from './component003';
import Component004 from './component004';
import Component010 from './component010';
import Component011 from './component011';
import Component012 from './component012';
import Component013 from './component013';
import Component014 from './component014';

const Components: {
  [key: string]: FunctionComponent<any>;
} = {
  Quiz,
  CourseLanding,
  SectionTitle,
  Conversation,
  Animation001,
  Animation002,
  Animation003,
  Animation004,
  Animation005,
  Animation006,
  Animation013,
  Animation040,
  Animation042,
  Animation044,
  Animation045,
  Animation046,
  Animation047,
  Component001,
  Component002,
  Component003,
  Component004,
  Component010,
  Component011,
  Component012,
  Component013,
  Component014,
};

export default Components;
